require('vendor')

const R = require('ramda')
const $ = require('jquery')
const Vue = require('vue')
const VueRouter = require('vue-router')
const bus = require('./std/bus')

window.globalBus = bus

if (window.Sentry) {
    window.Sentry.configureScope(scope => {
        scope.addEventProcessor((event, a) => {
            console.log(a)
            if (a && a.originalException && a.originalException.skip) {
                return Promise.resolve(null)
            }
            // Add anything to the event here
            // returning null will not send the event
            return Promise.resolve(event)
        })
    })
}

class SCI {
    static bus () {
        return bus
    }
    /**
     * @param key
     * @returns {*}
     */
    static get (key) {
        if (document.hasOwnProperty('SCI_DATA')) {
            if (document['SCI_DATA'].hasOwnProperty(key)) {
                return document['SCI_DATA'][key]
            }
        }
        return null
    }

    static set (key, value) {
        if (document.hasOwnProperty('SCI_DATA')) {
            document['SCI_DATA'][key] = value
        }
    }

    static bootVue (component) {
        return SCI.boot().then(() => {
            return new Vue({
                name: 'vue-container',
                el: 'vue-container',
                template: `<sci-component></sci-component>`,
                components: { SciComponent: component }
            })
        })
    }

    /**
     * TODO: Intermediario para a realização do epico SCIONLINE-74
     */
    static bootVueRouter (setup) {
        return SCI.boot().then(() => {
            let $user = null
            let $instance = null
            let $isSystem = null

            if (document.hasOwnProperty('SCI_DATA') && document.SCI_DATA.hasOwnProperty('user')) {
                $user = document.SCI_DATA['user']
                $instance = $user.instance
                $isSystem = parseInt($user.id) === 1

                if (window.Sentry) {
                    window.Sentry.configureScope(scope => {
                        scope.setTag('instance_id', $instance.id)
                        scope.setTag('instance_code', $instance.code)

                        const contextUser = R.pick([
                            'id',
                            'email',
                            'name',
                            'created_at',
                            'updated_at',
                            'deleted_at',
                            'activated_at',
                            'verified_at',
                            'branch_id',
                            'can_access_from_any_ip',
                            'is_instance_owner',
                            'is_system',
                            'status',
                            'team_id',
                            'type'
                        ], $user)

                        if (document.SCI_DATA && document.SCI_DATA['token']) {
                            contextUser.token = document.SCI_DATA['token']
                        }

                        scope.setUser(contextUser)
                    })
                }
            }

            const router = new VueRouter({
                history: true
            })

            setup(router)

            router.beforeEach(function (transition) {
                let predicate = true

                if (transition.to && transition.to.guard) {
                    const guard = transition.to.guard
                    if (typeof guard === 'string') {
                        // if ($user.simple_permissions.hasOwnProperty(guard)) {
                        //     predicate = $user.simple_permissions[guard]
                        // }

                        if ($user.guards.hasOwnProperty(guard)) {
                            predicate = predicate || $user.guards[guard]
                        }
                    } else if (typeof guard === 'function') {
                        predicate = guard($user, $user.guards)
                    }
                }

                if (!predicate) {
                    location.href = '/'
                    transition.abort()
                } else {
                    if (transition.to && transition.to.defaultTo) {
                        const toName = transition.to.name
                        const defaultTo = transition.to.defaultTo

                        if (toName === defaultTo || transition.from.defaultTo === defaultTo) {
                            transition.next()
                        } else {
                            transition.redirect({
                                defaultTo: null,
                                params: transition.to.params,
                                name: transition.to.defaultTo
                            })
                        }
                    } else {
                        transition.next()
                    }
                }
            })

            return router.start({
                template: `<router-view></router-view>`
            }, 'vue-container')
        })
    }

    static boot () {
        // TODO: fix recursive requiring
        const System = require('./system')

        return System.boot().then(() => {
            /**
             * Aqui é um bom lugar para colocar tarefas pós boot,
             * sempre lembrando de manter o padrão de Promises para não
             * realizar tarefas fora do contexto, pois assim, quando chegar
             * no JS da view, por ser assincrono, essa tarefa perdera seu caminho.
             */
            $('#global-loading')
                .addClass('is-not-loading')
                .removeClass('first-loading')
            $('#everything-is-loading').remove()
            $('#ensure-everything-loaded').show()
            return null
        })
    }
}

module.exports = SCI



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/index.js